import { cva } from 'class-variance-authority';

export const downloadableItemVariants = cva(
  'flex-gap-3 items-center justify-between w-full py-4',
  {
    variants: {
      type: {
        default: '',
        pretty: 'bg-extra-light-gray px-4 rounded-sm',
      },
    },
    defaultVariants: {
      type: 'default',
    },
  }
);
